import type { Transition, Variants } from 'framer-motion';

export const DURATION = {
    fast: 0.14,
    base: 0.22,
    slow: 0.32,
} as const;

export const EXIT_RATIO = 0.7;

export const EASE_OUT: Transition['ease'] = [0.22, 1, 0.36, 1];
export const EASE_IN: Transition['ease'] = [0.64, 0, 0.78, 0];

export const SPRING: Transition = {
    type: 'spring',
    stiffness: 420,
    damping: 34,
    mass: 0.7,
};

export const FADE_UP: Variants = {
    hidden: { opacity: 0, y: 8 },
    visible: { opacity: 1, y: 0, transition: { duration: DURATION.base, ease: EASE_OUT } },
    exit: { opacity: 0, y: -4, transition: { duration: DURATION.base * EXIT_RATIO, ease: EASE_IN } },
};

export const FADE: Variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: DURATION.base, ease: EASE_OUT } },
    exit: { opacity: 0, transition: { duration: DURATION.fast, ease: EASE_IN } },
};

export const STAGGER: Variants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.04, delayChildren: 0.02 } },
};

export const STAGGER_SLOW: Variants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.07, delayChildren: 0.05 } },
};

export const POP: Variants = {
    hidden: { opacity: 0, scale: 0.6 },
    visible: { opacity: 1, scale: 1, transition: SPRING },
    exit: { opacity: 0, scale: 0.6, transition: { duration: DURATION.fast, ease: EASE_IN } },
};

export const SHELL_ENTER = {
    header: {
        hidden: { opacity: 0, y: -12 },
        visible: { opacity: 1, y: 0, transition: { duration: DURATION.slow, ease: EASE_OUT } },
    } as Variants,
    navbar: {
        hidden: { opacity: 0, x: -16 },
        visible: { opacity: 1, x: 0, transition: { duration: DURATION.slow, ease: EASE_OUT, delay: 0.06 } },
    } as Variants,
    content: {
        hidden: { opacity: 0, y: 12 },
        visible: { opacity: 1, y: 0, transition: { duration: DURATION.slow, ease: EASE_OUT, delay: 0.14 } },
    } as Variants,
};

export const LEVEL_SLIDE: Variants = {
    hidden: (direction: number) => ({ opacity: 0, x: direction * 28 }),
    visible: { opacity: 1, x: 0, transition: { duration: DURATION.base, ease: EASE_OUT } },
    exit: (direction: number) => ({
        opacity: 0,
        x: direction * -28,
        transition: { duration: DURATION.fast, ease: EASE_IN },
    }),
};

export const COLLAPSE_BRANCH: Variants = {
    hidden: { opacity: 0, height: 0 },
    visible: { opacity: 1, height: 'auto', transition: { duration: DURATION.base, ease: EASE_OUT } },
    exit: { opacity: 0, height: 0, transition: { duration: DURATION.base * EXIT_RATIO, ease: EASE_IN } },
};

export const PRESS = { scale: 0.97 } as const;
export const HOVER_LIFT = { y: -2 } as const;

export const stepPanel = (direction: 1 | -1): Variants => ({
    hidden: { opacity: 0, x: direction * 24 },
    visible: { opacity: 1, x: 0, transition: { duration: DURATION.base, ease: EASE_OUT } },
    exit: {
        opacity: 0,
        x: direction * -24,
        transition: { duration: DURATION.base * EXIT_RATIO, ease: EASE_IN },
    },
});
